import React from 'react';
import LocationTemplate from './LocationTemplate';

const WeldonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Weldon"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27890"]}
      latitude={36.4271}
      longitude={-77.6041}
      population={1655}
      historicalFact="Once known as 'The Rockfish Capital of the World'; important railroad junction in the 19th century."
      nearbyTowns={[
        "Halifax, NC",
        "Enfield, NC",
        "Roanoke Rapids, NC",
        "Scotland Neck, NC",
        "Littleton, NC",
        "Warrenton, NC",
        "Henderson, NC",
        "Garysburg, NC"
      ]}
    />
  );
};

export default WeldonPage;